import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Column from '../../../../models/SpreadsheetReportConfigs/Column.js';
import { useDrag } from 'react-dnd';
import './index.scss';

const ItemTypes = {
  COLUMN: 'column',
};

const OutputColumnDNDItem = ({
  groupName,
  column,
  index,
  onDelete,
  onUpdateName,
  originalLabel,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(column.name);
  const shouldShowOriginalLabel =
    originalLabel && originalLabel !== column.name;

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.COLUMN,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = () => {
    if (editValue.trim()) {
      onUpdateName(column.id, editValue.trim());
      setIsEditing(false);
    }
  };

  const handleInputChange = (e) => {
    setEditValue(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && editValue.trim()) {
      handleSaveClick();
    } else if (e.key === 'Escape') {
      setEditValue(column.name);
      setIsEditing(false);
    }
  };

  return (
    <div
      ref={drag}
      className={`output-column-dnd-item ${
        isDragging
          ? 'output-column-dnd-item-dragging'
          : 'output-column-dnd-item-normal'
      }`}
    >
      <div className='output-column-dnd-item-content'>
        <div className='output-column-dnd-item-group-name'>{groupName}</div>
        {isEditing ? (
          <div className='output-column-dnd-item-edit-wrapper'>
            <input
              type='text'
              value={editValue}
              onChange={handleInputChange}
              onKeyDown={handleKeyPress}
              className='output-column-dnd-item-edit-input'
              autoFocus
            />
            {shouldShowOriginalLabel && (
              <span className='output-column-dnd-item-original-name output-column-dnd-item-original-name-editing'>
                {`(${originalLabel})`}
              </span>
            )}
          </div>
        ) : (
          <span className='output-column-dnd-item-column-name'>
            {column.name}
            {shouldShowOriginalLabel && (
              <span className='output-column-dnd-item-original-name'>
                {`(${originalLabel})`}
              </span>
            )}
          </span>
        )}
      </div>
      <div className='output-column-dnd-item-actions'>
        {isEditing ? (
          <>
            <i
              className='fa fa-check output-column-dnd-item-icon output-column-dnd-item-icon-save'
              onClick={handleSaveClick}
            />
            <i
              className='fa fa-times output-column-dnd-item-icon output-column-dnd-item-icon-cancel'
              onClick={() => {
                setEditValue(column.name);
                setIsEditing(false);
              }}
            />
          </>
        ) : (
          <i
            className='fa fa-pencil output-column-dnd-item-icon output-column-dnd-item-icon-edit'
            onClick={handleEditClick}
          />
        )}
        <i
          className='fa fa-trash output-column-dnd-item-icon output-column-dnd-item-icon-delete'
          onClick={() => onDelete(column.id)}
        />
      </div>
    </div>
  );
};

OutputColumnDNDItem.propTypes = {
  groupName: PropTypes.string,
  column: PropTypes.shape(Column.propTypes).isRequired,
  index: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
  onUpdateName: PropTypes.func.isRequired,
  originalLabel: PropTypes.string,
};

export default OutputColumnDNDItem;
